import fp from "lodash/fp";
import { IOption } from "constants/types";
import { Field, SchemaRecord } from "records/schema";

export const CartRedirect = {
    ENTRYPOINT: "entryPoint",
    HOME: "home",
};

export enum PRODUCTS_FILTER {
    NONE = "",
    BY_WAREHOUSE_IN_WO = "by_warehouse_in_wo",
}

/**
 * Generates a list of group by options according to the same logic as in WO.
 * @param {SchemaRecord} schema - order schema to get fields from.
 * @param {Function} t - format message function to translate default messages.
 * @returns {IOption[]} list of options.
 */
export const getGroupSettings = (schema: SchemaRecord, t = (key: string) => key): IOption[] => [
    { value: "ship_start", label: t("Delivery") },
    ...fp.compose(
        fp.map((field: Field) => ({ value: field.key.split(".")[1], label: field.name })),
        fp.filter(
            (field: Field) =>
                /^line_items\./.test(field?.key) &&
                field?.details?.type === "single" &&
                field?.details?.subtype === "lookup" &&
                !!field?.details?.lookup &&
                (field?.display || field?.display_to_buyers),
        ),
    )(schema?.fields?.toJS()),
    { value: "none", label: t("None") },
];

/**
 * Generates a list of sort by options according to the same logic as in WO.
 * @param {Function} [t] - format message function to translate default messages.
 * @returns {IOption[]} list of options.
 */
export const getSortSettings = (t = (key: string) => key): IOption[] => [
    { value: "ship_start", label: t("Ship Start") },
    { value: "created_on", label: t("Added to cart") },
    { value: "name", label: t("Name") },
    { value: "style_number", label: t("Style Number") },
    { value: "color", label: t("Color") },
    { value: "total_quantity", label: t("Unit Count") },
    { value: "total", label: t("Line Item Value") },
];
